import Masonry from 'masonry-layout';
import "url-polyfill";
import {
    parse
}
from 'querystring';
import './global/photomodal';

const parsedUrl = new URL(window.location.href);
const tabParam = parsedUrl.searchParams.get("tab");

const loadingIndicator = document.querySelector('.js-loadingIndicator');

// Grid Setup
const masonryGrids = [...document.querySelectorAll('.js-photoGrid')];
const masonryGridInitArray = [];

masonryGrids.forEach((grid, i) => {
    masonryGridInitArray[i] = new Masonry(grid, {
        columnWidth: '.js-photoSizer',
        itemSelector: '.js-photoGridItem',
        gutter: 5,
        initLayout: false,
        dataTab: grid.getAttribute('data-tab'),
    });
});

if (!tabParam) {
    parsedUrl.searchParams.append('tab', masonryGridInitArray[0].options.dataTab);
    window.history.replaceState({}, document.title, parsedUrl.href);
}

document.querySelector(`.js-portfolioTab[data-tab="${parsedUrl.searchParams.get("tab")}"]`).classList.add("-active");
document.querySelector(`.js-portfolioTabLink[data-tab="${parsedUrl.searchParams.get("tab")}"]`).classList.add("-active");

masonryGridInitArray.forEach(gridInit => {
    if (gridInit.options.dataTab == parsedUrl.searchParams.get("tab")) {
        loadingIndicator.classList.remove('active');
        setTimeout(() => {
            gridInit.layout()
        }, 200);
    }
});

// Tab Functionality
const gridTabs = [...document.querySelectorAll('.js-portfolioTab')];
const tabLinks = [...document.querySelectorAll('.js-portfolioTabLink')]

tabLinks.forEach(link => {
    link.addEventListener('click', () => {
        let dataTab = link.getAttribute('data-tab');
        let currentTab = document.querySelector(`.js-portfolioTab[data-tab="${dataTab}"]`);

        gridTabs.forEach(tab => tab.classList.remove('-active'));
        tabLinks.forEach(link => link.classList.remove('-active'));

        currentTab.classList.add('-active');
        link.classList.add("-active");
        masonryGridInitArray.forEach(gridInit => {
            if (gridInit.options.dataTab == dataTab) {
                gridInit.layout()
                parsedUrl.searchParams.set('tab', dataTab);
                window.history.replaceState({}, document.title, parsedUrl.href);
            }
        });
    });
});